import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CdkDrag, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AfterViewInit, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { InventoryService } from 'app/services/inventory.service';
import { PrintService } from 'app/services/print.service';
import { element } from 'protractor';
import { quantity } from 'chartist';
import { L } from '@angular/cdk/keycodes';
// import { da } from 'date-fns/locale';
// import { Paginator } from 'primeng/paginator';

@Component({
	selector: 'app-bommodal',
	templateUrl: './bommodal.component.html',
	styleUrls: ['./bommodal.component.scss']
})
export class BommodalComponent implements OnInit, OnChanges {
	@Input() openclosed: any = false;
	@Output() closeEvent = new EventEmitter < boolean > ();
	@ViewChild('paginator') paginator: MatPaginator;
	@ViewChild('breakdownModal') breakdownKit: ElementRef;



	lookup = new UntypedFormControl('');
	componentlookup = new UntypedFormControl('');
	searchsub: any;
	itemlist: any;
	showlist: boolean;
	noresults: boolean;
	activeBom: any = [];
	user: any = [];
	breakqty: any = 0;
	bomForm: FormGroup < {} > = new FormGroup({});
	parentForm: FormGroup < {} > = new FormGroup({});
	bomParentEditing: any = false;
	componentitemlist: any = [];
	bdData: any = [];
	componentdatasource: any = new MatTableDataSource([]);
	componentsearching: boolean;
	showcomponentlist: boolean;
	componentnoresults: boolean;
	componentsearchsub: any;
	searching = false;


	componentdisplayedColumns: string[] = [
		'stockid',
		'description',
		'loccode',
		'mfgpart',
		'action'
	];

	formsub: any = false;



	constructor(public inventoryService: InventoryService, private globalSearchService: GlobalSearchService, private printService: PrintService, private modalService: NgbModal, public fb: FormBuilder) {}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.openclosed.currentValue) {
			this.openLookup(changes.openclosed.currentValue)
		}
	}


	ngAfterViewInit(): void {

	}

	ngOnInit(): void {
		this.globalSearchService.user.subscribe(result => {
			this.user = result;
		});

	}

	validateId(event: any) {
		const data = {
			new_id: event.value,
			original_id: this.activeBom['bomParent']
		};
		this.inventoryService.absoluteKitSearch(data).subscribe((results: any) => {
			if (results.length == 0) {
				this.bomForm.get('activeBomParent').clearValidators();
			} else {
				this.bomForm.get('activeBomParent').addValidators([Validators.required, this.validateKitId()]);
			}
			this.bomForm.get('activeBomParent').updateValueAndValidity();
		});

	}

	private validateKitId(): ValidatorFn {
		return (control: AbstractControl): {
			[key: string]: any
		} => {
			const input = {
				new_id: control.value,
				original_id: this.activeBom['bomParent']
			};
			return this.inventoryService.absoluteKitSearch(input).subscribe(({ data }) => {

				return data;
			},
			(error) => {

				return error;
			}
			);
		}
	}


	openLookup(stockid) {


		const data = {
			bomParent: stockid
		}

		this.activeBom = [];

		this.searchsub = this.inventoryService.explodeBom(data).subscribe((results: any) => {

			if (results.length > 0) {
				this.activeBom = results;
				this.activeBom['bomParent'] = stockid;

				let activeafter = results[0].effectiveafter;
				let activeto = results[0].effectiveto;

				results.forEach(component => {
					if (activeto > component.effectiveto) {
						activeto = component.effectiveto;
					}
					if (activeafter < component.effectiveto) {
						activeafter = component.effectiveafter
					}
				});

				this.activeBom['bomParent_effectiveto'] = activeto;
				this.activeBom['bomParent_effectiveafter'] = activeafter;

				this.activeBom.forEach(part => {
					this.bomForm.addControl(part.component, new FormControl(part.quantity))
					this.bomForm.addControl(part.component + '_effectiveto', new FormControl(part.effectiveto))
					this.bomForm.addControl(part.component + '_effectiveafter', new FormControl(part.effectiveafter))
				});

				this.bomForm.addControl('activeBomParent', new FormControl(this.activeBom['bomParent'], Validators.required))
				this.bomForm.addControl('activeBomParent_effectiveafter', new FormControl(this.activeBom['bomParent_effectiveafter']))
				this.bomForm.addControl('activeBomParent_effectiveto', new FormControl(this.activeBom['bomParent_effectiveto']))

				// this.formlistener();
			} else {

				this.activeBom['bomParent'] = stockid;
				this.activeBom['bomParent_effectiveto'] = '';
				this.activeBom['bomParent_effectiveafter'] = '';
				this.bomForm.addControl('activeBomParent', new FormControl(this.activeBom['bomParent'], Validators.required))
				this.bomForm.addControl('activeBomParent_effectiveafter', new FormControl(this.activeBom['bomParent_effectiveafter']))
				this.bomForm.addControl('activeBomParent_effectiveto', new FormControl(this.activeBom['bomParent_effectiveto']))
			}

			this.masterDate();
			this.bomParentEditing == true ?
				this.bomParentEditing = false : this.bomParentEditing = true;
		});
	}


	close() {
		this.closeEvent.emit(false);
	}


	componentSearch() {
		// if (this.componentlookup.value != '' ) {
		const data = {};
		data['stockid'] = this.componentlookup.value;
		data['type'] = ['component'];
		this.searching = true;
		this.componentsearchsub = this.inventoryService.itemSearch(data).subscribe((results: any) => {
			this.searching = false;
			this.componentitemlist = results
			this.componentdatasource = new MatTableDataSource(results);
			this.componentdatasource.paginator = this.paginator;
			this.componentsearching = false;
		});
	}


	removeComponent(component: any) {
		Object.keys(this.bomForm.value).forEach((key) => {
			const formattedKey = key.split('_')[0];
			if (component.component == formattedKey) {
				this.bomForm.removeControl(key);
			}
		})

		for (let x = 0; x < this.activeBom.length; x++) {
			if (component.component == this.activeBom[x].component) {
				this.activeBom.splice(x, 1);
			}
		}

		this.shuffleSequence();
		// this.updateBom();
	}

	formlistener() {

		this.bomForm.valueChanges.subscribe((newV) => {

			this.updateBom();
		})
	}

	masterDate() {
		this.bomForm.get('activeBomParent_effectiveto').valueChanges.subscribe((newV) => {
			Object.keys(this.bomForm.controls).forEach(key => {
				if (key.split('_')[1] == 'effectiveto' && key.split('_')[0] != 'activeBomParent') {
					this.bomForm.get(key).setValue(newV)
					alert(newV);
				}
			});
		});
		this.bomForm.get('activeBomParent_effectiveafter').valueChanges.subscribe((newV) => {

			Object.keys(this.bomForm.controls).forEach(key => {
				if (key.split('_')[1] == 'effectiveafter' && key.split('_')[0] != 'activeBomParent') {
					this.bomForm.get(key).setValue(newV)
					alert(newV);
				}
			});
		});
	}


	drop(event: CdkDragDrop < string[] > ) {
		moveItemInArray(this.activeBom, event.previousIndex, event.currentIndex);
		this.shuffleSequence();
		// this.updateBom();
	}

	shuffleSequence() {
		for (let x = 0; x < this.activeBom.length; x++) {
			this.activeBom[x].sequence = (x + 1);
		}
	}

	editBomParent() {
		this.openLookup(this.activeBom.bomParent);


	}

	updateBom() {
		const data = {};
		//get objects (components) from activebom object
		this.activeBom.forEach(element => {
			typeof element == 'object' ? data[element.sequence - 1] = element : '';
			if (data[element.sequence - 1]) {
				const comp = data[element.sequence - 1].component;
				data[element.sequence - 1].effectiveafter = this.bomForm.get(`${comp}_effectiveafter`).value;
				data[element.sequence - 1].effectiveto = this.bomForm.get(`${comp}_effectiveto`).value;
				data[element.sequence - 1].quantity = this.bomForm.get(comp).value;
			}
		});

		data['parent'] = this.activeBom['bomParent'];

		this.searchsub = this.inventoryService.updateBom(data).subscribe((results: any) => {
			// this.activeBom['bomParent'] = this.bomForm.get('activeBomParent').value;
		});
	}

	renameBomParent() {
		//not needed - leaving in for now
		// if(this.bomForm.get('activeBomParent').valid){
		// 	let data = {
		// 		newParent: this.bomForm.g cartet('activeBomParent').value,
		// 		originalParent: this.activeBom['bomParent']
		// 	}

		// 	this.searchsub = this.inventoryService.renameBom(data).subscribe((results: any) => {
		// 		this.activeBom['bomParent'] = this.bomForm.get('activeBomParent').value;
		// 	});

		// };
		// this.updateBom();
	}

	validityAlert() {
		alert('This parent\'s stockid is already present. \nPlease enter an ID that isn\'t in use');
	}

	saveAndClose() {

		this.updateBom();
		this.editBomParent();
	}

	addToBom(component: any) {
		let valid = true;
		const adding = component.stockid;
		const parent = this.activeBom['bomParent'];
		const effectiveto = this.activeBom['bomParent_effectiveto'];
		const effectiveafter = this.activeBom['bomParent_effectiveafter'];

		// Check for duplicates or self-reference
		valid = !this.activeBom.some(active => {
			const present = active['component'];
			return typeof present === 'string' && (adding === present || adding === parent);
		});

		if (!valid) {
			alert(`Duplicate items and parents can't be added to the BOM.\n\nCancelling addition of '${adding}'.`);
			return;
		}

		// Construct new BOM entry
		const data = {
			parent: parent,
			description: component.description,
			sequence: (this.activeBom.length + 1).toString(),
			component: component.stockid,
			loccode: component.loccode,
			effectiveto: effectiveto,
			effectiveafter: effectiveafter,
			quantity: '1'
		};

		// Add form controls if not already present
		if (!this.bomForm.contains(component.stockid)) {
			this.bomForm.addControl(component.stockid, new FormControl('1'));
		}
		if (!this.bomForm.contains(component.stockid + '_effectiveto')) {
			this.bomForm.addControl(component.stockid + '_effectiveto', new FormControl(effectiveto));
		}
		if (!this.bomForm.contains(component.stockid + '_effectiveafter')) {
			this.bomForm.addControl(component.stockid + '_effectiveafter', new FormControl(effectiveafter));
		}

		// Push and refresh sequence
		this.activeBom.push(data);
		this.shuffleSequence();
	}

	breakdown() {

		this.inventoryService.getBreakdown({ stockid: this.activeBom['bomParent'], loccode: this.user.user.defaultlocation.loccode }).subscribe((results: any) => {
			this.bdData = results;
			this.modalService.open(this.breakdownKit, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {

			});
		});

	}

	updateBD(event: any) {
		const mult = event;
		this.bdData.bomlines.forEach(bomline => {
			bomline.qtyadd = bomline.quantity * mult;
			this.breakqty = event;
		});
	}

	processBreakdown() {
		this.inventoryService.postBreakdown({ stockid: this.activeBom['bomParent'], loccode: this.user.user.defaultlocation.loccode, qty: this.breakqty }).subscribe((results: any) => {
			this.bdData = results;
			this.modalService.dismissAll();
		});
	}

	isAlreadyInBom(stockid: string): boolean {
		return this.activeBom.some(item => item.component === stockid);
	}
}